import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { CollectionsService } from 'src/app/services/common/collections.service';

@Component({
  selector: 'app-reg-person-visit-form',
  templateUrl: './reg-person-visit-form.component.html',
  styleUrls: ['./reg-person-visit-form.component.css']
})
export class RegPersonVisitFormComponent implements OnInit {
  @Input() visit: UntypedFormGroup;

  lstCompanies = this.coll.COMPANIES.slice();
  lstRanks = this.coll.RANKS.slice();

  lstNeedBadges: number[] = [
    13, // Докладчик
    6, // Оргкомитет
    10, // Почетный гость
    11 // Представитель компании
  ];

  lstLogic: SelectItem[] = [
    { label: "Да", value: true},
    { label: "Нет", value: false},
  ];

  constructor(
    private coll: CollectionsService
  ) { }

  ngOnInit(): void {
  }

  onRankChanged(e: any) {
    if (this.lstNeedBadges.indexOf(+e.value) !== -1) {
      this.visit.patchValue({isNeedBadge: true});
    }
  }
}
